import { motion } from "framer-motion";
import { useHandleNavClickCommunityPage } from "../hooks/useHandleNavClick";
import { Link } from "react-router-dom";

export default function JoinUsSection() {

  const handleNavClick = useHandleNavClickCommunityPage()

  return (
    <motion.section
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      className="relative bg-cover bg-center bg-primary text-center text-secondary px-4 py-16 sm:py-20 lg:py-24"
      style={{ backgroundImage: `url(/images/background.png)` }}
    >
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="w-full max-w-4xl mx-auto flex flex-col items-center gap-6"
      >
        <motion.h2 className="font-extrabold leading-tight text-[clamp(2rem,1.714rem+1.429vw,3.5rem)]">
          Become Part of Something Great
        </motion.h2>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.3 }}
          className="text-balance text-base sm:text-lg max-w-prose"
        >
          Join our fast-growing tech tribe, connect with like-minded innovators,
          earn rewards, and unlock exclusive perks – all while learning,
          growing, and having fun.
        </motion.p>

        <motion.div whileHover={{ scale: 1.05 }}>

           <Link to='https://chat.whatsapp.com/GGDf21NCgcfA5R5z3hRBrv' className="inline-block px-8 sm:px-12 py-3 font-semibold rounded-full bg-secondary text-primary hover:opacity-90"
          >
            Join us today
          </Link>
        </motion.div>
      </motion.div>

      <div className="absolute bottom-0 left-0 w-full h-8 rounded-tl-2xl rounded-tr-2xl bg-black"></div>
    </motion.section>
  );
}
